'use client'

import React, { useEffect } from 'react'
import { initBugsnag, ErrorBoundary } from '@/lib/bugsnag'

export default function BugsnagProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize Bugsnag on client-side
    initBugsnag()
  }, [])

  // Only wrap with ErrorBoundary if BugSnag is enabled
  if (!process.env.NEXT_PUBLIC_BUGSNAG_API_KEY) {
    return <>{children}</>
  }

  return <ErrorBoundary>{children}</ErrorBoundary>
}
